import { type FC, type ReactNode } from "react";
import DefinitionTooltip from "src/components/common/DefinitionTooltip";

interface RestaurantSectionCardProps {
  title: string;
  tip?: string;
  action?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
  footer?: ReactNode;
}

const RestaurantSectionCard: FC<RestaurantSectionCardProps> = ({
  title,
  tip,
  action,
  className = "",
  bodyClassName = "",
  children,
  footer,
}) => (
  <section className={`restaurant-analytics-dashboard__card ${className}`.trim()}>
    <div className="restaurant-analytics-dashboard__card-head">
      <div className="restaurant-analytics-dashboard__card-title-row">
        <h3 className="restaurant-analytics-dashboard__card-title">{title}</h3>
        {tip ? (
          <DefinitionTooltip label={title} info={{ description: tip }} align="start" />
        ) : null}
      </div>
      {action}
    </div>
    <div className={`restaurant-analytics-dashboard__card-body ${bodyClassName}`.trim()}>
      {children}
    </div>
    {footer ? <div className="restaurant-analytics-dashboard__card-footer">{footer}</div> : null}
  </section>
);

export default RestaurantSectionCard;
